{
  "ascending": "vzestupně",
  "ascendingSort": "řazeno vzestupně podle sloupce {columnName}",
  "collapse": "Sbalit",
  "columnSize": "{value} pixelů",
  "descending": "sestupně",
  "descendingSort": "řazeno sestupně podle sloupce {columnName}",
  "expand": "Roztáhnout",
  "resizerDescription": "Stisknutím klávesy Enter začnete měnit velikost",
  "select": "Vybrat",
  "selectAll": "Vybrat vše",
  "sortable": "sloupec s možností řazení"
}
